import { ENTERING, EXITING } from "./constants";
/**
 * Gets the `window.setTimeout` duration that should be used for a given stage.
 * This will return `0` for all stagees except for `ENTERING` and `EXITING`.
 *
 * @internal
 */
export function getTimeoutDuration(stage, appear, enter, exit, appearing) {
    if (stage === ENTERING) {
        return appearing ? appear : enter;
    }
    if (stage === EXITING) {
        return exit;
    }
    return 0;
}
//# sourceMappingURL=getTimeoutDuration.js.map